export default {
  headline: "Einstellungsprotokoll",
  personal: {
    headline: "Persönliches",
    personal_number: "Personalnummer",
    first_name: "Vorname*",
    first_name_invalid: "Bitte geben Sie ihren Vornamen an",
    last_name: "Nachname*",
    last_name_invalid: "Bitte geben Sie ihren Vornamen an",
    birthdate: "Geburtsdatum*",
    birthdate_invalid: "Bitte geben Sie ihr Geburtsdatum an",
    activity: "Tätigkeit",
    street: "Strasse",
    postcode: "PLZ",
    city: "Ort",
    phone: "Telefon",
    fax: "Fax",
    mail: "E-Mail"
  },
  contact: {
    headline: "Kontakt"
  },
  working_stuff: {
    headline: "",
    tax_class: "Steuerklasse",
    social_security_number: "Sozialversicherungsnummer",
    health_insurance: "Krankenkasse",
    start_of_work: "Firmeneintritt",
    company: "Firma",
    branch: "Niederlassung"
  },
  qualifications: {
    headline: "Qualifizierungen",
    facharbeiterzeugnisse: "Facharbeiterzeugnisse",
    meisterbriefe: "Meisterbriefe",
    zertifikate: "Zertifikate",
    zusaetzliche_berechtigungen: "Zusätzliche Berechtigungen",
    fuehrerschein: "Führerschein",
    personenbefoerderungsschein: "Personenbeförderungsschein",
    medizinische_untersuchungen: "Medizinische Untersuchungen",
  }
}
